var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkersComp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.33 305.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-4{stroke-width:16px;}.cls-2,.cls-7{stroke-width:11px;}.cls-3,.cls-6{stroke-width:10px;}.cls-4,.cls-7{fill:#227ff8;}.cls-5{fill:#fff;stroke-width:17px;}.cls-6{fill:#277bfa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.3,84.13h67.02c0-37.27-30.25-67.94-67.02-67.94S37.28,46.86,37.28,84.13H104.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.76,296.54H38.25c-16.37,0-29.75-13.39-29.75-29.75v-55.61c0-16.37,13.38-29.75,29.75-29.75h44.96l21.09,72.36,12.46,42.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.21,181.43h90.87c16.36,0,29.75,13.38,29.75,29.75v85.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.3,86.42H47.85c0,34.52,25.48,62.93,56.45,62.93s56.45-28.41,56.45-62.93h-56.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.52,
    y1: 86.42,
    x2: 179.08,
    y2: 86.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "91.84 38.06 91.84 5 116.76 5 116.76 38.06"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 136.22,
    y1: 11.11,
    x2: 136.22,
    y2: 38.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.37,
    y1: 11.11,
    x2: 72.37,
    y2: 38.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162,275.17c0,5.87-2.41,11.22-6.28,15.09-3.87,3.88-9.21,6.28-15.09,6.28h-23.87l-12.46-42.75h36.33c11.75,0,21.37,9.62,21.37,21.38Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkersComp);
export default __webpack_public_path__ + "static/media/workersComp.4418490810c2a68397728c296c634314.svg";
export { ForwardRef as ReactComponent };